/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Features_DescriptionInputs */

const en_meta_features_description = /** @type {(inputs: Meta_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transform your academic reading experience with AI-powered text-to-speech. Perfect for researchers and students on the go.`)
};

const es_meta_features_description = /** @type {(inputs: Meta_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforma tu experiencia de lectura académica con texto a voz impulsado por IA. Perfecto para investigadores y estudiantes en movimiento.`)
};

/**
* | output |
* | --- |
* | "Transform your academic reading experience with AI-powered text-to-speech. Perfect for researchers and students on the go." |
*
* @param {Meta_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_features_description = /** @type {((inputs?: Meta_Features_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Features_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_features_description(inputs)
	return en_meta_features_description(inputs)
});